module.exports = __webpack_public_path__ + "static/media/espace_vie_scolaire.c71b042f.png";